import React, { useState } from 'react'

import Select from '../../forms/Select'
import { FilterColumnButton } from '../FilterColumnButton'
import { FilterPill } from '../FilterPill'
import { FilterTypePopup } from './FilterTypePopup'
import { getDynamicOptions } from '../filter.helpers'

export const FilterTypeSelect = ({
  customPlaceholder,
  autoFocus = true,
  isClearable = true,
  schema = {},
  rows,
  value,
  loading,
  updateSearch,
  columnAccessor,
  showAllOnEmpty = false,
  showLabel = true,
  handleUpdateFilter,
  ...props
}) => {
  const [open, setOpen] = useState(false)

  const options = schema.options || getDynamicOptions(rows, schema)
  const isSelected = options.some((option) => option.value === value)
  const displayLabel = options.find(
    (option) => option?.value.toString() === value?.toString()
  )?.label

  return (
    <FilterTypePopup
      open={open}
      setOpen={setOpen}
      position={columnAccessor ? 'top left' : 'bottom left'}
      trigger={
        columnAccessor ? (
          <FilterColumnButton
            type="select"
            columnAccessor={columnAccessor}
            displayLabel={displayLabel || schema.label}
            value={value}
            hasValue={isSelected}
          />
        ) : (
          <FilterPill
            customPlaceholder={customPlaceholder}
            showAllOnEmpty={showAllOnEmpty}
            clickable
            isClearable={isClearable && isSelected}
            handleRemoveFilter={(event) => {
              event.stopPropagation()

              updateSearch(schema.accessor, '')
            }}
            loading={loading}
            label={schema.label}
            value={displayLabel}
            showLabel={showLabel}
            active={open}
            {...props}
          />
        )
      }
    >
      <Select
        isClearable={isClearable}
        autoFocus={autoFocus}
        menuIsOpen
        label={schema.label}
        options={options}
        loading={loading}
        value={value}
        // The pill popup is a floating-ui popover: a body-portaled menu renders outside
        // it (misplaced, since the popover is positioned after mount) and option clicks
        // count as outside presses that dismiss the popup before onChange fires.
        menuPortalTarget={null}
        onChange={(option, action) => {
          if (action.action === 'clear') {
            updateSearch(schema.accessor, '')
          } else {
            if (handleUpdateFilter) {
              handleUpdateFilter(option.value)
            }
            updateSearch(schema.accessor, option.value)
          }
          setOpen(false)
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            setOpen(false)
          }
        }}
      />
    </FilterTypePopup>
  )
}
